/**
 * Created by rickborst on 25/04/2017.
 */

/**
 * Converts playback rules data from read data.
 *
 * @param {Object} [data] - Read data.
 * @returns {Object} Playback rules data.
 */
export function convertFromRead (data = {}) {

    return {
        enableCatchUp: data.enableCatchUp || false,
        enableCdvr: data.enableCdvr || false,
        enableNonPrivilegedRecording: data.enableRecordingPlaybackNonEntitledChannel || false,
        enableRestart: data.enableStartOver || false,
        enableTrickPlay: data.enableTrickPlay || false,
        trickPlayBuffer: data.trickPlayBuffer || 0,
        catchUpBuffer: data.catchUpBuffer || 0
    };
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/playbackrules.js